import { render, staticRenderFns } from "./ClicksStatsTable.vue?vue&type=template&id=263639a6&scoped=true"
import script from "./ClicksStatsTable.vue?vue&type=script&lang=js"
export * from "./ClicksStatsTable.vue?vue&type=script&lang=js"
import style0 from "./ClicksStatsTable.vue?vue&type=style&index=0&id=263639a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263639a6",
  null
  
)

export default component.exports